import { ZSpecCommon } from "src/business/specification";

import { AttrVisitor } from "../../AttrVisitor";
import { walkAttrsInSpecs } from "../../AttrVisitor/walkAttr";
import { ZAttrMeta } from "../../ZAttrMeta";

export interface AttrDetails {
  uid: string;
  attr: ZAttrMeta;
  spec: ZSpecCommon;
  level: number;
  ownerIds: string[];
}

/**
 * Получить плоский список атрибутов из списка спецификаций,
 * при этом сразу отфильтровываются те атрибуты, которые не должны попадаить в список
 * В левый список попадают не выбранные атрибуты (полностью или частично), в правый - выбранные.
 */
export const buildAttrsList = (
  specs: ZSpecCommon[],
  isAttrVisible: (uid: string) => boolean,
) => {
  const result: AttrDetails[] = [];
  const visitor: AttrVisitor = {
    isSkip({ uid }) {
      return !isAttrVisible(uid);
    },
    onEach(attr, ctx) {
      if (ctx.spec)
        result.push({
          uid: attr.uid,
          attr,
          spec: ctx.spec,
          level: ctx.owners?.length ?? 0,
          ownerIds: ctx.owners?.map(({ uid }) => uid) ?? [],
        });
    },
  };
  walkAttrsInSpecs(specs, visitor);
  return result;
};
